import React from "react";
import { Button, ButtonProps } from "@material-ui/core";

type ConfirmButtonProps = ButtonProps;
export const ConfirmButton: React.FC<ConfirmButtonProps> = ({
  children,
  ...props
}) => {
  return (
    <Button
      data-testid="Button--submit"
      disableElevation
      size="large"
      variant="contained"
      color="primary"
      {...props}
    >
      {children ? children : "Confirm"}
    </Button>
  );
};
